/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { FaMicrophone, FaMicrophoneSlash, FaPaperPlane, FaSpinner } from "react-icons/fa";
import { DID } from '../../actions';

// Browser's SpeechRecognition API
const SpeechRecognition =
    window.SpeechRecognition || window.webkitSpeechRecognition;
const recognition = new SpeechRecognition();


const HomeScrollSectionThree = () => {
    const [loading, setLoading] = useState(false);
    const [isListening, setIsListening] = useState(false);
    const videoRef = useRef(null);
    const [inputValue, setInputValue] = useState("");

    const handleSubmit = () => {
        DID.setupWebRTCStream(videoRef.current, inputValue);
    };


    // Initialize SpeechRecognition
    useEffect(() => {
        recognition.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            setInputValue(transcript);
            setIsListening(false);
        };

        recognition.onerror = (event) => {
            console.error("Error occurred in speech recognition: ", event.error);
            setIsListening(false);
        };
    }, []);

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    };

    const handleMicClick = () => {
        if (!isListening) {
            recognition.start();
            setIsListening(true);
        } else {
            recognition.stop();
            setIsListening(false);
        }
    };

    console.log(videoRef, 'videoRef')

    return (
        <>
            <div id="section-three" className="background-container d-flex justify-content-center align-items-center">
                <video className="background-video" autoPlay muted loop>
                    <source src="/video/home1.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                <main className="main-section">
                    <h1 className='text_36_home text-black'>   Eira Avatar Pages  </h1>
                    <div className="avatar-container">
                        {/* {
                            videoRef?.current === null ? (
                                <img src="/img/home4.jpg" alt="Black male avatar" className="avatar" />
                            ) : ( */}
                        <video ref={videoRef} autoPlay style={{ width: "100%", height: "auto" }}></video>
                        {/* ) */}
                        {/* } */}

                    </div>
                    <div className="send-input-container">
                        {isListening ? (
                            <FaMicrophoneSlash
                                className="icon microphone-icon active"
                                onClick={handleMicClick}
                            />
                        ) : (
                            <FaMicrophone className="icon microphone-icon" onClick={handleMicClick} />
                        )}
                        <input
                            type="text"
                            value={inputValue}
                            required
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyPress={handleKeyPress}
                            disabled={loading}
                            placeholder="Type your message..."
                            className="send-input"
                        />
                        {loading ? (
                            <FaSpinner className="icon loading-icon" />
                        ) : (
                            <button style={{
                                border: "none",
                                background: "transparent",
                                cursor: "pointer",
                                outline: "none"
                            }}
                                onClick={handleSubmit}
                                type='submit'
                            >
                                <FaPaperPlane className="icon send-icon" />
                            </button>
                        )}
                    </div>
                </main>

                <aside className="progress-indicator">
                    <div className="indicator-item active"></div>
                    <div className="indicator-item"></div>
                    <div className="indicator-item"></div>
                </aside>
            </div>
        </>
    )
}

export default HomeScrollSectionThree

